let inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];

class ByFavoritesService {
    constructor($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
        this.$q = $q;
        this.$http = $http;
        this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
        this.ngAuthSettings = ngAuthSettings;
        this.AuthTokenFactory = AuthTokenFactory;
        this.SharedService = SharedService;
        this.SessionService = SessionService;
    }

    getProductsFavorites(userId,currentPage,itemsPerPage) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: `${this.ngAuthSettings.apiServiceBaseUri}${this.ngAuthSettings.config.paths.fastSearchFavoriteItems}&userId=${userId}&pageNumber=${currentPage}&pageSize=${itemsPerPage}`,
                cache: false,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        })
    }

    getResumeProductsFavorites(userId) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: `${this.ngAuthSettings.apiServiceBaseUri}${this.ngAuthSettings.config.paths.fastSearchResumeFavoriteItems}?userId=${userId}&origen=B2B`,
                cache: false,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        })
    }

    getProducts(text, userId) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: `${this.ngAuthSettings.apiServiceBaseUri}${this.ngAuthSettings.config.paths.searchProduct}${text}&userId=${userId}`,
                cache: false,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    updateFavoriteProducts(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.setFavoriteProduct,
                cache: true,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

}

ByFavoritesService.$inject = inject;

export default ByFavoritesService;



/** WEBPACK FOOTER **
 ** ./www/components/fast-purchase/by-favorites/by-favorites.service.js
 **/